import React from "react";
import { Helmet } from "react-helmet-async";
import SigmaOgImage from "../images/sigma-og-image.png";
import { checkOs } from "./helpers";
import { OperatingSystems } from "./vendor";

interface RenderHeadersParams {
  title: string;
  description: string;
  image?: string;
  ogTitle?: string;
  ogDescription?: string;
  canonicalUrl?: string;
  showAppBanner?: boolean;
}

export function renderHeaders({
  title,
  description,
  image,
  ogTitle,
  ogDescription,
  canonicalUrl = window.location.href,
  showAppBanner = false,
}: RenderHeadersParams) {
  const os = checkOs();
  const deviceIsIos = os === OperatingSystems.Ios;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="theme-color" content="#1f1975" />
      <meta name="description" content={description} />
      <meta name="og:title" content={ogTitle || title} />
      <meta name="og:description" content={ogDescription || description} />
      <meta name="og:image" content={image || SigmaOgImage} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {/* TODO: Uncomment this when the iOS app is published and we can get the app-id */}
      {/* {showAppBanner && deviceIsIos && (
        <meta
          name="apple-itunes-app"
          content={`app-id=1631502021, app-argument=${canonicalUrl}`}
        />
      )} */}
    </Helmet>
  );
}

export function extractOgTitleFromMainTitle(title: string) {
  return title.slice(0, title.indexOf("|") - 1);
}
